import { SetState } from './../../utils/type';
import { Option } from '../../utils/option';
import { NextRouter } from 'next/router';
import BasePresenter from '../basePresenter';
import tracker from '../../gateways/tracker/tracker';
import { EVENT } from '../../gateways/tracker/events';
import userInteractor from '../../application/usecases/userInteractor';
import {
  EditableUserProfile,
  SecureUserProfile,
  UserProfile
} from '../../gateways/api/models';
import { captureException } from '@sentry/nextjs';

export default class UpdatePresenter extends BasePresenter {
  constructor(
    readonly router: Option<NextRouter>,
    readonly setIsUpdateLoading: SetState<boolean>,
    readonly setServerErrMsg: SetState<string>
  ) {
    super(router);
  }

  onUpdate = async (
    secureUserProfile: SecureUserProfile | null,
    updatedUserProfile: EditableUserProfile
  ): Promise<void | UserProfile> => {
    this.setIsUpdateLoading(true);
    this.setServerErrMsg('');

    const updatedProfile: SecureUserProfile = secureUserProfile
      ? {
          ...secureUserProfile,
          first_name: updatedUserProfile.firstName,
          last_name: updatedUserProfile.lastName,
          nickname: updatedUserProfile.nickname,
          location: updatedUserProfile.location
        }
      : {
          name: '',
          gender: '',
          birth_date: '',
          nationality: '',
          nickname: updatedUserProfile.nickname,
          first_name: updatedUserProfile.firstName,
          last_name: updatedUserProfile.lastName,
          location: updatedUserProfile.location
        };
    try {
      const result = await userInteractor.updateMyInfo(updatedProfile);
      return result.fold(
        ({ message }) => {
          this.setServerErrMsg(message);
        },
        (updatedProfile) => {
          tracker.track(EVENT.USER_NAME_UPDATED);
          tracker.track(EVENT.USER_LOCATION_UPDATED);
          tracker.track(EVENT.USER_NICKNAME_UPDATED);
          return updatedProfile;
        }
      );
    } catch (e) {
      captureException(e);
    } finally {
      this.setIsUpdateLoading(false);
    }
  };
}
